var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 27H0.785156V9.48047H6.23438V27ZM3.48047 7.13672C1.78125 7.13672 0.375 5.67188 0.375 3.91406C0.375 2.80078 0.960938 1.74609 1.89844 1.21875C2.89453 0.632812 4.125 0.632812 5.0625 1.21875C6.05859 1.74609 6.64453 2.80078 6.64453 3.91406C6.64453 5.67188 5.23828 7.13672 3.48047 7.13672ZM26.5664 27H21.1758V18.5039C21.1758 16.4531 21.1172 13.875 18.3047 13.875C15.4922 13.875 15.082 16.043 15.082 18.3281V27H9.63281V9.48047H14.8477V11.8828H14.9062C15.668 10.5352 17.4258 9.07031 20.0625 9.07031C25.5703 9.07031 26.625 12.7031 26.625 17.3906V27H26.5664Z",
    fill: "url(#paint0_linear_7_225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_225",
    x1: 0,
    y1: 16,
    x2: 27,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7578EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22AAF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.18eccf7573fbd9a739f2a7cb0daf35fc.svg";
export { ForwardRef as ReactComponent };